import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

export default function Blog() {
  useSEO({
    title: 'Real Estate Blog | Market Insights & Tips | Jeffery Long eXp Realty California',
    description: 'Latest real estate insights, market trends, buying tips, and selling strategies from Jeffery Long. Expert advice on Northern California real estate, Sacramento market analysis, home buying guides, and investment property tips. CA DRE #02234432',
    keywords: 'real estate blog, California real estate news, Sacramento market trends, home buying tips, selling strategies, real estate insights, property investment, Northern California real estate',
    canonical: '/blog',
    ogTitle: 'Real Estate Blog | Market Insights & Expert Tips',
    ogDescription: 'Latest insights and tips from our real estate experts. Stay informed about market trends, buying tips, and industry news.',
    ogImage: 'https://public.readdy.ai/ai/img_res/dce6376147fba96265fd72aa7a834c25.jpg',
    ogType: 'website',
    schema: {
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Jeffery Long Real Estate Blog",
      "description": "Real estate insights, market trends, and expert advice from Jeffery Long and the eXp Realty team.",
      "url": "SITE_URL/blog",
      "publisher": {
        "@type": "RealEstateAgent",
        "name": "Jeffery Long - eXp Realty",
        "logo": {
          "@type": "ImageObject",
          "url": "https://dtzulyujzhqiu.cloudfront.net/expcorporate377/profiles/1727374637.png"
        }
      }
    }
  });

  const blogPosts = [
    {
      id: 1,
      slug: 'working-on-my-exp-team',
      title: "Working on My eXp Team: Why Joining Jeffery Long\u2019s eXp Realty Group Is the Best Career Move for Real Estate Agents in California",
      excerpt: "The real estate industry in the United States is evolving faster than ever. Technology, shifting consumer expectations, and new brokerage models are reshaping how agents build their careers. If you are a licensed real estate agent in California\u2014or thinking about getting your license\u2014discover why joining Jeffery Long\u2019s eXp Realty team offers the best commission splits, revenue sharing, stock awards, mentorship, and technology tools in the industry...",
      author: "Jeffery Long",
      date: "May 30 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=professional%20real%20estate%20team%20collaboration%20meeting%20in%20modern%20cloud%20based%20office%20with%20diverse%20agents%20discussing%20strategy%20around%20conference%20table%20with%20laptops%20and%20property%20documents%20warm%20lighting&width=400&height=250&seq=exp-team-hero-blog-99&orientation=landscape"
    },
    {
      id: 2,
      slug: null,
      title: "Discovering the Best Realtor in California: Why Jeffery Long Stands Out in the USA Real Estate Market",
      excerpt: "In the vast and competitive world of real estate, finding the best realtor in the USA can feel like searching for a needle in a haystack. With countless agents vying for attention, how do you identify someone who truly excels? If you\u2019re specifically looking for the best realtor in California...",
      author: "Jeffery Long",
      date: "May 28 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=professional%20real%20estate%20agent%20Jeffery%20Long%20standing%20confidently%20in%20front%20of%20California%20luxury%20properties%20with%20modern%20office%20setting%20and%20success%20achievement%20awards&width=400&height=250&seq=blog-jeffery-featured&orientation=landscape"
    },
    {
      id: 3,
      slug: null,
      title: "Top Ten Services a Realtor Can Provide to Sell a Customer's House",
      excerpt: "Top Ten Services a Realtor Can Provide to Sell a Customer's House. Pricing the Home Accurately. A realtor's top job is setting the right price. In Cameron Park, where home values can vary...",
      author: "Jeffery Long",
      date: "May 25 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=professional%20real%20estate%20agent%20showing%20house%20to%20clients%20with%20for%20sale%20sign%20in%20front%20of%20beautiful%20home&width=400&height=250&seq=blog-1&orientation=landscape"
    },
    {
      id: 4,
      slug: null,
      title: "Buying Homeowner Insurance in Cameron Park",
      excerpt: "Navigating Homeowner Insurance in Cameron Park: Your Ultimate Guide. Buying homeowner insurance in Cameron Park, California, isn't just about checking a box—it's about protecting...",
      author: "Jeffery Long",
      date: "May 23 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=homeowner%20insurance%20documents%20and%20house%20model%20on%20desk%20with%20calculator%20and%20pen%20professional%20setting&width=400&height=250&seq=blog-2&orientation=landscape"
    },
    {
      id: 5,
      slug: null,
      title: "How to Add an ADU to Your Property in Sacramento",
      excerpt: "How to Add an ADU to Your Property in Sacramento. Imagine turning your Sacramento backyard into a cozy guesthouse for your in-laws, a rental unit that pays for itself, or a private home office that...",
      author: "Jeffery Long",
      date: "April 24 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=modern%20accessory%20dwelling%20unit%20ADU%20construction%20in%20backyard%20with%20architectural%20plans%20and%20tools&width=400&height=250&seq=blog-3&orientation=landscape"
    },
    {
      id: 6,
      slug: null,
      title: "Ready to Sell Your Business in Sacramento? 5 Must-Know Tips for Success",
      excerpt: "Ready to Sell Your Business in Sacramento? 5 Must-Know Tips for Success. So, you're thinking about selling your business in Sacramento? That's a big move! Whether you're ready to...",
      author: "Jeffery Long",
      date: "April 19 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=business%20for%20sale%20sign%20in%20front%20of%20commercial%20building%20with%20professional%20real%20estate%20setting&width=400&height=250&seq=blog-4&orientation=landscape"
    },
    {
      id: 7,
      slug: null,
      title: "Sacramento Real Estate Market Trends 2025",
      excerpt: "Understanding the current market trends in Sacramento and what they mean for buyers and sellers. Get insights into pricing, inventory levels, and future predictions...",
      author: "Jeffery Long",
      date: "April 15 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=Sacramento%20California%20skyline%20with%20real%20estate%20market%20charts%20and%20graphs%20overlay%20professional%20analysis&width=400&height=250&seq=blog-5&orientation=landscape"
    },
    {
      id: 8,
      slug: null,
      title: "First-Time Homebuyer's Guide to Northern California",
      excerpt: "Everything you need to know as a first-time homebuyer in Northern California. From financing options to neighborhood selection, we cover all the essentials...",
      author: "Jeffery Long",
      date: "April 10 2025",
      comments: 0,
      image: "https://readdy.ai/api/search-image?query=happy%20young%20couple%20holding%20house%20keys%20in%20front%20of%20their%20new%20home%20with%20real%20estate%20agent&width=400&height=250&seq=blog-6&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-teal-900 to-teal-700 text-white py-20">
          <div className="absolute inset-0 bg-black/30"></div>
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=modern%20blog%20writing%20workspace%20with%20laptop%20computer%20and%20real%20estate%20magazines%20on%20clean%20desk&width=1200&height=600&seq=blog-hero&orientation=landscape')`
            }}
          ></div>
          <div className="relative container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Real Estate Blog</h1>
            <p className="text-xl md:text-2xl mb-8">Latest insights and tips from our real estate experts</p>
            <p className="text-lg">Stay informed about market trends, buying tips, and industry news</p>
          </div>
        </section>

        {/* Featured Post */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-12">
                <img 
                  src={blogPosts[0].image} 
                  alt={blogPosts[0].title}
                  className="w-full h-64 object-cover"
                />
                <div className="p-8">
                  <div className="flex items-center text-sm text-gray-600 mb-4">
                    <span>Posted by {blogPosts[0].author}</span>
                    <span className="mx-2">•</span>
                    <span>{blogPosts[0].date}</span>
                    <span className="mx-2">•</span>
                    <span>{blogPosts[0].comments} comments</span>
                  </div>
                  <h2 className="text-3xl font-bold mb-4 text-gray-900">{blogPosts[0].title}</h2>
                  <p className="text-gray-700 leading-relaxed mb-6">{blogPosts[0].excerpt}</p>
                  {blogPosts[0].slug && (
                    <Link 
                      to={`/blog/${blogPosts[0].slug}`}
                      className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold"
                    >
                      Read More
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">Latest Posts</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.slice(1).map((post) => (
                <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-600 mb-3">
                      <span>By {post.author}</span>
                      <span className="mx-2">•</span>
                      <span>{post.date}</span>
                    </div>
                    <h3 className="text-xl font-bold mb-3 text-gray-900 line-clamp-2">{post.title}</h3>
                    <p className="text-gray-700 text-sm leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                    {post.slug && (
                      <div className="flex items-center justify-between">
                        <Link 
                          to={`/blog/${post.slug}`}
                          className="text-teal-600 hover:text-teal-700 font-semibold text-sm flex items-center"
                        >
                          Read More
                          <i className="ri-arrow-right-line ml-1"></i>
                        </Link>
                        <span className="text-gray-500 text-sm">{post.comments} comments</span>
                      </div>
                    )}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Categories */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">Browse by Category</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-4-line text-2xl text-teal-600"></i>
                </div>
                <h3 className="font-semibold">Buying Tips</h3>
                <p className="text-sm text-gray-600 mt-1">12 articles</p>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-price-tag-3-line text-2xl text-green-600"></i>
                </div>
                <h3 className="font-semibold">Selling Tips</h3>
                <p className="text-sm text-gray-600 mt-1">8 articles</p>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-line-chart-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="font-semibold">Market Trends</h3>
                <p className="text-sm text-gray-600 mt-1">15 articles</p>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <i className="ri-calculator-line text-2xl text-red-600"></i>
                </div>
                <h3 className="font-semibold">Financing</h3>
                <p className="text-sm text-gray-600 mt-1">6 articles</p>
              </div>
            </div>
          </div>
        </section>

        {/* Newsletter Signup */}
        <section className="py-16 bg-teal-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Stay Updated</h2>
            <p className="text-xl mb-8">Subscribe to our newsletter for the latest real estate insights</p>
            <div className="max-w-md mx-auto">
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="Enter your email address"
                  className="flex-1 px-4 py-3 rounded-l-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-300"
                />
                <button className="bg-red-600 hover:bg-red-700 px-6 py-3 rounded-r-lg font-semibold transition-colors whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
